/* src/app/private/components/tickets/ticket-activity-tab/ticket-activity-tab.component.scss */
.activity-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.loading-activities-container {
  background: var(--surface-ground, #fafafa);
  border-radius: 0.75rem;
  margin: 1rem;
  padding: 2rem;
  text-align: center;
}
.loading-activities-container .loading-text h4 {
  color: var(--text-color, #495057);
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}
.loading-activities-container .loading-text p {
  color: var(--text-color-secondary, #6c757d);
  margin: 0;
  font-size: 0.875rem;
}
.timeline-and-comment-container {
  display: flex;
  flex-direction: column;
}
.timeline-section {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  width: 100%;
}
.timeline-section app-ticket-timeline {
  width: 100%;
  display: block;
}
.comment-section {
  border-top: 2px solid #e5e7eb;
  padding: 1rem;
  min-height: 120px;
}
.comment-input-container {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
}
.comment-textarea {
  flex: 1;
  resize: none;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 0.75rem;
  font-size: 14px;
}
.comment-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.send-button {
  background-color: var(--primary-color) !important;
  border: none !important;
  padding: 0.75rem 1rem !important;
  border-radius: 8px !important;
  height: fit-content;
  min-width: 50px;
}
.send-button:hover:not(:disabled) {
  background-color: var(--primary-color-dark) !important;
}
.send-button:disabled {
  background-color: #9ca3af !important;
  cursor: not-allowed;
}
.timeline-section::-webkit-scrollbar {
  width: 8px !important;
}
.timeline-section::-webkit-scrollbar-thumb {
  background-color: var(--secondry-light-gray) !important;
  border-radius: 20px !important;
}
.timeline-section::-webkit-scrollbar-track {
  background-color: transparent !important;
}
/*# sourceMappingURL=ticket-activity-tab.component.css.map */
